import Image from 'next/image';
import Link from 'next/link';

import { cn } from '@/libs';
import type { PartnershipItem } from '@/types/models/Partnership';

type FooterPartnershipsProps = {
  label?: string;
  items: PartnershipItem[];
  className?: string;
};

const DEFAULT_LABEL = 'Parceiros';
const LOGO_STYLE = {
  width: 'auto',
  height: '50px',
  maxWidth: '160px',
  objectFit: 'contain',
} as const;

export function FooterPartnerships({ label, items, className }: FooterPartnershipsProps) {
  if (items.length === 0) {
    return null;
  }

  return (
    <div data-cy="footer-partnerships" className={cn('mb-6', className)}>
      <h3 className="mb-2 text-primary-foreground text-xs md:text-2xl font-bold">
        {label || DEFAULT_LABEL}
      </h3>
      <div className="flex flex-row flex-wrap items-center gap-4">
        {items.map((item, index) => {
          const key = `${item.name}-${index}`;
          const logo = (
            <Image
              src={item.logo}
              alt={item.name}
              width={160}
              height={50}
              style={LOGO_STYLE}
            />
          );

          if (item.link) {
            return (
              <Link key={key} href={item.link}>
                {logo}
              </Link>
            );
          }

          return <div key={key}>{logo}</div>;
        })}
      </div>
    </div>
  );
}
